// extracted by mini-css-extract-plugin
module.exports = {"main-component":"converted_main-component__3bX38"};